import type { ComponentProps } from 'react';

import styles from './header.component.module.scss';
import { PrivateContentContainer } from './private/private-content.container';
import { PublicContentContainer } from './public/public-content.component';

type Props = {
  isLogin: boolean;
  isShowMobileNavigation?: boolean;
} & ComponentProps<'header'>;

export const Header = ({ isLogin, isShowMobileNavigation, ...rest }: Props) => {
  return (
    <header className={styles.header} {...rest}>
      {isLogin ? (
        <PrivateContentContainer
          isShowMobileNavigation={isShowMobileNavigation}
        />
      ) : (
        <PublicContentContainer />
      )}
    </header>
  );
};
